export default () => ({
  isOpenFilter: false,
  pagination: {},
  rows: [],
  filter: {}
});
